import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DashboardLayout from "@/components/DashboardLayout";
import ProjectCard from "@/components/ProjectCard";
import { api } from "@/lib/api";

export default function SavedItems() {
  const { t } = useTranslation();
  const [data, setData] = useState({ projects: [], briefs: [] });

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/api/saved");
      setData(data);
    })();
  }, []);

  return (
    <DashboardLayout title={t("saved.title")} subtitle={t("saved.subtitle")}>
      {data.projects.length === 0 && data.briefs.length === 0 ? (
        <div className="kpi-card p-8 text-center text-slate-500">{t("saved.empty")}</div>
      ) : (
        <>
          {data.projects.length > 0 && (
            <>
              <h2 className="font-display text-2xl text-petroleum mb-4">{t("saved.projects_title")}</h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
                {data.projects.map((p) => <ProjectCard key={p.id} project={p} theme="light" />)}
              </div>
            </>
          )}
          {data.briefs.length > 0 && (
            <>
              <h2 className="font-display text-2xl text-petroleum mb-4">{t("saved.briefs_title")}</h2>
              <div className="grid md:grid-cols-2 gap-4">
                {data.briefs.map((b) => (
                  <div key={b.id} className="kpi-card p-5">
                    <h3 className="font-display text-xl text-petroleum">{b.title}</h3>
                    <p className="text-sm text-slate-500 mt-2 line-clamp-3">{b.description}</p>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
}
